import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { LoginComponent } from './login/login.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { PasswordResetFormComponent } from './password-reset-form/password-reset-form.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { ProfileComponent } from './profile/profile.component';
import { RegisterComponent } from './register/register.component';
import { IsAuthenticatedGuard } from './shared/guards/is-authenticated.guard';
import { UserProfileResolver } from './shared/resolvers/user-profile.resolver';

const routes: Routes = [
	{ path: '', redirectTo: '/login', pathMatch: 'full' },
	{ path: 'login', component: LoginComponent },
	{ path: 'login/:step', component: LoginComponent },
	{ path: 'register', component: RegisterComponent },
	{ path: 'register/:step', component: RegisterComponent },
	{ path: 'profile', component: ProfileComponent, canActivate: [IsAuthenticatedGuard], resolve: { user: UserProfileResolver } },
	{ path: 'email-confirmation', component: EmailConfirmationComponent, canActivate: [IsAuthenticatedGuard] },
	{ path: 'password-reset-form', component: PasswordResetFormComponent },
	{ path: 'password-reset', component: PasswordResetComponent },
	{ path: 'password-change', component: PasswordChangeComponent, canActivate: [IsAuthenticatedGuard] },
	{ path: 'error', component: ErrorPageComponent },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
	providers: [IsAuthenticatedGuard]
})
export class AppRoutingModule { }
